import axios from 'axios'

const axiosObj = axios.create({
  baseURL: `${process.env.REACT_APP_ADMIN_BASE_URL}/v1`,
  headers: {
    'Content-Type': 'application/json'
  },
  responseType: 'json'
})

const rejectionReasonFIService = {
  addRejectionReasonsFI: async (data) => {
    try {
      const response = await axiosObj.post('/rejection-reasons-fi', data)
      return response.data
    } catch (err) {
      console.log(err)
      return err.response
    }
  },
  getRejectionReasonsFI: async (machine) => {
    try {
      const response = await axiosObj.get('/rejection-reasons-fi', {
        params: { machine }
      })
      return response.data
    } catch (err) {
      console.log(err)
      return err.response
    }
  }
}

export default rejectionReasonFIService
